// getUserDisplayNameMapFromFirestore.js
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());

/**
 * Firestoreのusersコレクションから全ユーザーのuid→displayNameマップを取得
 * @returns {Promise<Object>} uid: displayName のマップ
 */
export async function getUserDisplayNameMapFromFirestore() {
  const usersCol = collection(db, 'users');
  const snapshot = await getDocs(usersCol);
  const map = {};
  snapshot.forEach(doc => {
    const data = doc.data();
    map[data.uid] = data.displayName || '';
  });
  return map;
}
